import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PropertyItem } from '../../core/models/property.model';

@Pipe({
  name: 'orderTranslate',
  standalone: false
})
export class OrderTranslatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(array: Array<PropertyItem>): Array<PropertyItem> {
    return [...array].sort((a: PropertyItem, b: PropertyItem) => {
      const textA = a.NameId ? this.translate.instant(a.NameId) : a.Value;
      const textB = b.NameId ? this.translate.instant(b.NameId) : b.Value;
      if (textA < textB) {
        return -1;
      } else if (textA > textB) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}
